<template>
  <!--
    A "Desk" groups several organizations. The option list is derived from the
    distinct `desk` values across all organizations (set manually in the DB),
    so adding a desk to an org in the DB makes it appear here automatically.

    On change it emits:
      • input    — the selected desk name(s)
      • resolved — { orgIds, buIds } for every org (and its branches) in the
                   selected desk(s), so the parent can auto-fill the org / BU
                   pickers.
  -->
  <base-filter-select
      v-model="model"
      :options="deskOptions"
      :multiple="true"
      :clearable="clearable"
      :select-props="mergedSelectProps"
      :placeholder="placeholder"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue'

export default {
  name: 'DeskSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: {
      required: true,
    },
    selectProps: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('data', ['allOrganizations', 'allBusinessUnits']),
    mergedSelectProps() {
      return { ...this.selectProps, disabled: this.disabled || this.selectProps.disabled === true }
    },
    deskOptions() {
      const desks = (this.allOrganizations || [])
          .map(o => o.desk)
          .filter(d => d != null && String(d).trim() !== '')
      return [...new Set(desks)].sort((a, b) => String(a).localeCompare(String(b)))
    },
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
        this.$emit('resolved', this.resolve(v))
      },
    },
  },
  methods: {
    resolve(desks) {
      const list = Array.isArray(desks) ? desks : (desks != null ? [desks] : [])
      if (list.length === 0) {
        return { orgIds: [], buIds: [] }
      }
      const orgIds = (this.allOrganizations || [])
          .filter(o => list.includes(o.desk))
          .map(o => o.id)
      const buIds = (this.allBusinessUnits || [])
          .filter(bu => orgIds.includes(bu.orgId))
          .map(bu => bu.id)
      return { orgIds, buIds }
    },
  },
}
</script>
